import L from "leaflet";

export default ($el: Element) => {
	if ($el instanceof HTMLElement) {
		const identifier = $el.getAttribute("data-identifier");
		const jsonElement = $el.getAttribute("data-applicationdata");
		const centerLat = $el.getAttribute("data-centerLat");
		const centerLon = $el.getAttribute("data-centerLon");
		const mapZoom = $el.getAttribute("data-mapZoom");

		let zoom = 13;
		if (mapZoom) {
			zoom = parseInt(mapZoom);
		}

		if (identifier) {
			let lat = 47.761
			let lon = 11.565

			if (centerLat && centerLon) {
				lat = parseFloat(centerLat);
				lon = parseFloat(centerLon);
			}

			var map = L.map(
				identifier,
				{
					touchZoom: false,
					doubleClickZoom: false,
					zoomControl: false,
					boxZoom: false,
					scrollWheelZoom: false,
					keyboard: false,
					dragging: false
				}
			).setView([lat, lon], zoom);

			if (jsonElement) {
				const poiData = JSON.parse(jsonElement);

				Object.values(poiData).forEach(({label, lat, lon, figure}) => {
					let content = "<div>";

					if (figure) {
						content += figure;
					}

					content += label;
					content += "</div>";
					if (label && lat && lon) {
						L.marker(
							[lat, lon]
						).addTo(map).bindPopup(content);
					}
				})

				var OpenStreetMap_DE = L.tileLayer('https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png', {
					maxZoom: 18,
					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				});

				OpenStreetMap_DE.addTo(map);
			}
		}
	}
}
